import { render, staticRenderFns } from "./save-id.vue?vue&type=template&id=e34a8696&"
import script from "./save-id.vue?vue&type=script&lang=js&"
export * from "./save-id.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports